import { ID } from "@closerplatform/closer-sdk/dist/protocol/protocol";
import { UserProfile } from "./models/userProfile";
import { ArtichokeService } from "./services/artichokeService";

export type UserGetter = (id: ID, room: ID) => UserProfile | undefined;
export type Marks = { [type: string]: number };

// TODO: refactor: move, remove array from parameters
export const markLastMessage = (
  context: { artichokeService: ArtichokeService },
  roomId: string,
  messages: ArrayLike<{ timestamp: number }>
) => {
  if (messages.length !== 0) {
    const last = messages[messages.length - 1]!.timestamp;
    context.artichokeService.setMark(roomId, last);
  }
};
